import 'core-js/fn/object/'
import 'core-js/fn/array/find'
import 'core-js/fn/array/find-index'
import 'core-js/fn/array/fill'
import 'core-js/fn/array/includes'
import 'core-js/fn/string/starts-with'
import 'core-js/fn/string/includes'
// add polyfills below are due to IE10/11 bugs
// coming from some library/code, which is not our code
import 'core-js/fn/string/ends-with'
import 'core-js/fn/symbol/iterator'
import 'core-js/fn/weak-set'
import 'core-js/fn/weak-map'
import 'core-js/fn/number/is-finite' // to be removed when recharts fixes their stuff  - https://github.com/recharts/recharts-scale/issues/8

// TODO (kasperkronborg): When IE11 support is dropped this can be removed
// @see https://github.com/pmndrs/zustand/issues/119
import 'core-js/fn/regexp'

import 'regenerator-runtime/runtime'

// Polyfill for window.performance.now() - missing in IE9
// https://gist.github.com/paulirish/5438650
function polyfillWindowPerformance() {
  if ('performance' in window === false) {
    window.performance = {}
  }
  Date.now =
    Date.now ||
    function dateNow() {
      return new Date().getTime()
    }
  if ('now' in window.performance === false) {
    let nowOffset = Date.now()
    if (performance.timing && performance.timing.navigationStart) {
      nowOffset = performance.timing.navigationStart
    }
    window.performance.now = function now() {
      return Date.now() - nowOffset
    }
  }
}
polyfillWindowPerformance()

const Map = require('core-js/library/es6/map')
const Set = require('core-js/library/es6/set')

function polyfillMapAndSet() {
  if ('Map' in window === false) {
    window.Map = Map
  }

  if ('Set' in window === false) {
    window.Set = Set
  }
}

polyfillMapAndSet()

const Promise = require('core-js/library/es6/promise')
// Temp fix for IE Promise not defined
if ('Promise' in window === false) {
  window.Promise = Promise
}
